<template>
  <path
    d="M19.65 9.04018L14.81 8.62018L12.92 4.17018C12.58 3.36018 11.42 3.36018 11.08 4.17018L9.18995 8.63018L4.35995 9.04018C3.47995 9.11018 3.11995 10.2102 3.78995 10.7902L7.45995 13.9702L6.35995 18.6902C6.15995 19.5502 7.08995 20.2302 7.84995 19.7702L12 17.2702L16.15 19.7802C16.91 20.2402 17.8399 19.5602 17.6399 18.7002L16.54 13.9702L20.2099 10.7902C20.8799 10.2102 20.5299 9.11018 19.65 9.04018ZM12 15.4002V6.10018L13.71 10.1402L18.09 10.5202L14.77 13.4002L15.77 17.6802L12 15.4002Z"
  />
</template>
